module.exports = __webpack_public_path__ + "img/tool4.9afe546.png";